const initialState = {
    dashboardDriveList: [],
    dashboardRoleList:[],
    dashboardDriveSingleList:[],
    dashboardDriveCandinateList: [],
    roleMetrics:[],
    degreeList: [],
    dashboardDriveStudent:[],
    getSpecialisationListForReport:{}
  }
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case 'SET_DASHBOARD_DRIVE_LIST':
        return {
          ...state,
          dashboardDriveList: action.list,
        }
        case 'SET_DASHBOARD_ROLE_LIST':
            return {
              ...state,
              dashboardRoleList: action.list,
        }
        case 'SET_DASHBOARD_DRIVE_SINGLE_LIST':
          return {
            ...state,
            dashboardDriveSingleList: action.list,
      }
      case 'SET_CANDIDATE_DRIVE_LIST':
        return {
          ...state,
          dashboardDriveCandinateList: action.list,
    }
    case 'SET_ROLE_METRICS':
      return {
        ...state,
        roleMetrics: action.data,
      }
      case 'SET_DEGREE_LIST':
        return {
          ...state,
          degreeList: action.data,
        }
        case 'SET_SINGLE_ROLE_STUDENT_DETAILS':
          return {
            ...state,
            dashboardDriveStudent: action.data,
          }

          case 'SET_SPECIALISATION_LIST':
            return {
              ...state,
              getSpecialisationListForReport: action.data,
            }
      default:
        return state
    }
  }
  